export default {
    items: [{
            title: true,
            name: 'Menú',
            class: '',
            wrapper: {
                element: '',
                attributes: {}
            }
        },
        {
            name: 'Inicio',
            url: '/inicio',
            icon: 'fa fa-home'
        }
        // {
        //     name: 'Usuarios',
        //     url: '/usuarios',
        //     icon: 'fa fa-users'
        // },
        // {
        //     name: 'Contraloría',
        //     url: '/contraloria',
        //     icon: 'icon-star',
        //     children: [{
        //         name: 'Declaraciones',
        //         url: '/contraloria/declaraciones',
        //         icon: 'fa fa-file-text'
        //     }]
        // }
    ]
}